import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { AvatarRarity } from '@common/contracts';
import ImageDropzone from '../ImageDropzone/ImageDropzone';
// One modal form for both Weapons and Armor, create + edit. Fields mirror the
// catalog: name, rarity, image, the 5 ability bonuses + power bonus.
const RARITIES = [
    { value: AvatarRarity.Common, label: 'Common' },
    { value: AvatarRarity.Rare, label: 'Rare' },
    { value: AvatarRarity.Epic, label: 'Epic' },
    { value: AvatarRarity.Legendary, label: 'Legendary' },
    { value: AvatarRarity.Mythic, label: 'Mythic' },
];
const BONUS_FIELDS = [
    { key: 'strengthBonus', label: 'Strength' },
    { key: 'perceptionBonus', label: 'Perception' },
    { key: 'agilityBonus', label: 'Agility' },
    { key: 'defenceBonus', label: 'Defence' },
    { key: 'intellectBonus', label: 'Intellect' },
    { key: 'powerBonus', label: 'Power' },
];
export function EquipmentModalForm({ isOpen, onClose, onSubmit, isLoading, mode, item, kind }) {
    const [name, setName] = useState('');
    const [rarity, setRarity] = useState(AvatarRarity.Common);
    const [image, setImage] = useState(null);
    const [bonuses, setBonuses] = useState({});
    const [nameError, setNameError] = useState('');
    useEffect(() => {
        if (!isOpen)
            return;
        if (mode === 'edit' && item) {
            setName(item.name);
            setRarity(item.rarity);
            setImage(item.image);
            setBonuses({
                strengthBonus: item.strengthBonus, perceptionBonus: item.perceptionBonus,
                agilityBonus: item.agilityBonus, defenceBonus: item.defenceBonus,
                intellectBonus: item.intellectBonus, powerBonus: item.powerBonus,
            });
        }
        else {
            setName('');
            setRarity(AvatarRarity.Common);
            setImage(null);
            setBonuses({});
        }
        setNameError('');
    }, [isOpen, item, mode]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setNameError('Name is required');
            return;
        }
        onSubmit({
            name: name.trim(),
            rarity,
            image,
            strengthBonus: bonuses.strengthBonus || 0,
            perceptionBonus: bonuses.perceptionBonus || 0,
            agilityBonus: bonuses.agilityBonus || 0,
            defenceBonus: bonuses.defenceBonus || 0,
            intellectBonus: bonuses.intellectBonus || 0,
            powerBonus: bonuses.powerBonus || 0,
        });
    };
    if (!isOpen || (mode === 'edit' && !item))
        return null;
    const kindLabel = kind === 'script' ? 'Weapon' : 'Armor';
    return (_jsx("div", { className: "modal-overlay", onClick: onClose, children: _jsxs("div", { className: "modal-content", onClick: e => e.stopPropagation(), children: [_jsxs("div", { className: "modal-header", children: [_jsx("h2", { children: mode === 'create' ? `Create ${kindLabel}` : `Edit ${kindLabel}` }), _jsx("button", { className: "close-button", onClick: onClose, disabled: isLoading, children: "\u00D7" })] }), _jsxs("form", { onSubmit: handleSubmit, className: "modal-form", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "equipName", children: "Name" }), _jsx("input", { id: "equipName", value: name, onChange: e => { setName(e.target.value); if (nameError)
                                        setNameError(''); }, disabled: isLoading, className: nameError ? 'error' : '' }), nameError && _jsx("span", { className: "error-text", children: nameError })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "equipRarity", children: "Rarity" }), _jsx("select", { id: "equipRarity", value: rarity, onChange: e => setRarity(Number(e.target.value)), disabled: isLoading, children: RARITIES.map(r => _jsx("option", { value: r.value, children: r.label }, r.value)) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Image" }), _jsx(ImageDropzone, { currentImageUrl: image, onUploadSuccess: setImage })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Characteristics" }), _jsx("div", { className: "equipment-bonus-grid", children: BONUS_FIELDS.map(f => {
                                        var _a;
                                        return (_jsxs("label", { className: "equipment-bonus-field", children: [_jsx("span", { children: f.label }), _jsx("input", { type: "number", value: (_a = bonuses[f.key]) !== null && _a !== void 0 ? _a : 0, onChange: e => setBonuses(b => (Object.assign(Object.assign({}, b), { [f.key]: Number(e.target.value) || 0 }))), disabled: isLoading })] }, f.key));
                                    }) })] }), _jsxs("div", { className: "modal-actions", children: [_jsx("button", { type: "button", onClick: onClose, disabled: isLoading, children: "Cancel" }), _jsx("button", { type: "submit", disabled: isLoading || !name.trim(), children: isLoading ? 'Saving...' : (mode === 'create' ? 'Create' : 'Save') })] })] })] }) }));
}
